import { DISTRIBUIDOR } from "utils/constants/papel_reach";


export default(substanceId, rawMaterialsById) => {

    const shipmentTagForSubstanceByShipmentID = {};

    rawMaterialsById[substanceId].inter_fornecedores.forEach(shipment => {
            if (shipment.papel_reach !== DISTRIBUIDOR && shipment.registos_directos[0].ce !== 'nao' && shipment.registos_directos[0].ce !== 'na') {
                shipmentTagForSubstanceByShipmentID[shipment.id] =
                    `[ ${shipment.codigo} ] - [ ${rawMaterialsById[substanceId].cod_mp} ] ${rawMaterialsById[substanceId].mp_nome} - 
       [ ${shipment.id_fornecedor.cod_fornecedor} ] ${shipment.id_fornecedor.fornecedor} - 
       ${shipment.designacao_comercial}`;
            }
        }
    );

    rawMaterialsById[substanceId].inter_misturas.forEach(mix =>
        rawMaterialsById[mix.id_mistura].inter_fornecedores.forEach(shipment => {
                if (shipment.papel_reach !== DISTRIBUIDOR && shipment.registos_directos[0].ce !== 'nao' && shipment.registos_directos[0].ce !== 'na') {
                    shipmentTagForSubstanceByShipmentID[shipment.id] =
                        `[ ${shipment.codigo} ] - [ ${rawMaterialsById[mix.id_mistura].cod_mp} ] ${rawMaterialsById[mix.id_mistura].mp_nome} - 
       [ ${shipment.id_fornecedor.cod_fornecedor} ] ${shipment.id_fornecedor.fornecedor} - 
       ${shipment.designacao_comercial}`;
                }
            }
        )
    );

    return shipmentTagForSubstanceByShipmentID;
};